<template>
    <section>
        <!-- {{surveyList[0].status}} -->
        <div class="mgt-24 pdb-17 shadow-bottom" v-if="surveyList.length>0 && (surveyList[0].status) && (surveyList[0].status.value === 'LEARNING')" >
            <div class="d-flex mgl-8 mgr-8 "  >
                <div class="w-40 mgl-8 mgr-8">
                    <img src="@/assets/banner_alarm_icon.svg" alt="">
                    
                </div>
                <div class="t-body2 mgl-8 mgr-8 align-self-center">
                    <!-- 새로 업데이트된 내용을 확인하세요. -->
                    {{$t('1961')}}
                </div>

            </div>
        </div>
        <div class="pda-default">
        <no-data v-if="!surveyList.length && dataLoadState"></no-data>

        <div class="mdc-card mdc-elevation--z3" v-if="surveyList.length">
            <div class="t-subtitle2 mgt-16 mgb-16 mgl-16 mgr-16">
                {{$t('1962')}}
                <!-- 정규평가 -->
            </div>
            
            <div v-for="(survey, index) in surveyList" :key="index" :class="addOpacityClass == true ? 'opacity-class':'ripple-item'">
                
                <div class="d-flex flex-row justify-content-between pdt-12 pdb-16 mgl-8 mgr-8 ">
                    <div class="pdl-8 pdr-8">
                        <img src="/images/survey/chat.png" class="profile">
                    </div>
                    <div class="pdl-8 pdr-8 flex-grow-1">
                        <div class="t-body1">
                            {{survey.name}}
                            <div class="t-body3 t-color-gray2">
                                <div v-if="(survey.status) && (survey.status.value === 'LEARNING')" @click="takeSurvey(survey.id,survey.respondentId,survey.type.value)">
                                <!-- <div> -->
                                    <span>
                                        {{$t('3006')}}
                                        <!-- 응시완료 -->
                                    </span>
                                </div>

                                <div v-if="(survey.status) && (survey.status.value === 'COMPLETION')">
                                <!-- <div> -->
                                    <span>
                                        {{$t('3060')}}
                                        <!-- 응시대기 -->
                                    </span>
                                </div>

                                <div v-if="(survey.status) && (survey.status.value === 'WAITING')" @click="takeNotSurvey()">
                                <!-- <div> -->
                                    <span>
                                        {{$t('1963')}}
                                        <!-- 응시대기 -->
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="d-flex flex-row" v-if="index < surveyList.length-1">
                    <div class="mgl-16 mgr-16 w-40"></div>
                    <div class="flex-grow-1">
                        <hr class="divider">
                    </div>
                </div>

                
            </div>
        </div>
    </div>
        
    </section>
</template>


<script>
/**
 * 나의 학습 상세 - 정규평가 탭 컴포넌트(my learning view - exam tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService'
import learnApi from '@/api/learnApi.js'
import NoData from '../../common/NoDataSurveyLesson.vue'
import {MDCRipple} from '@material/ripple'
export default {
    components: {
        'no-data': NoData
    },
    data() {
        return {
            surveyList: [],
            dataLoadState: false,
            addOpacityClass: false
        }
    },
    mounted() {
        //alert(this.$route.query.status)
        this.fetchData()
    },

    updated() {
        const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
            let ripple = new MDCRipple.attachTo(el)
            return ripple
        })
        
    },

    methods: {
        
        // 시험정보 API 호출 및 데이터 설정(get exam list data)
        fetchData() {
            let responseData = null
            let params = this.setParams()
            
            //this.$showLoading(this.$refs.examList)
            learnApi.learnViewSurveys(params).then((response) => {
                this.surveyList = response.data.data
                 if(response.data.data.length>0) {
                    this.dataLoadState = false
                } else {
                    this.dataLoadState = true
                }
                if((this.surveyList[0].status) && (this.surveyList[0].status.value === 'COMPLETION')) {
                    this.addOpacityClass = true
                } else {
                    this.addOpacityClass = false
                }
                //this.$hideLoading()
                //console.log('this.surveyList.length',response.data.data)
               
                

                // let applicableExamList = _.filter(this.surveyList, function(o) { return o.status === 'APPLICABLE' || o.status === 'REAPPLICATION' })
                
                // if (applicableExamList) {
                //     let examineeId = _.head(applicableExamList).examineeId
                //     this.setExamineeId(examineeId)
                // }
               
            }).catch((err) => {
                
            })
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                learnId: this.$route.params.learnId
            }
            return params
        },

        // 시험응시(move take exam)
        takeSurvey(id,respondentId,surveyDistributionType) {
            console.log("take survey Id",id)
             let params = {
                distId: id,
                respondentId: respondentId,
            }
            
            this.$router.push({
                name: 'IndependentSurveyIntro',
                params: params,
                query:{status:this.$route.query.status,learnId:this.$router.currentRoute.params.learnId,distributionType:surveyDistributionType}
            })
        },
        takeNotSurvey(){
            this.$alert({
              content: this.$t("3041"),
              accept: this.$t("3042"),
            })
              .then(() => {
              })
              .catch(() => {
              });
        }
        // setMissionId(examineeId) {
        //     this.$emit('setExamineeId', examineeId)
        // }

       
    }
}
</script>
<style scoped>
    .opacity-class{
        opacity: '';
    }
</style>